import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

import { Route, Routes } from "react-router-dom";
import DonationComponent from './components/DonationComponent'
import VirtualTerminalComponent from './components/VirtualTerminalComponent'
import Placeholder from './components/Placeholder';
import PlaceholderCampaign from './components/PlaceholderCampaign';
import CampaignComponent from './components/CampaignComponent';

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Placeholder />} />
        <Route path="/mjibril" element={<PlaceholderCampaign />} />
        <Route path="/preview/donate" element={<DonationComponent />} />
        <Route path="/preview/monthly" element={<DonationComponent />} />
        <Route path="/preview/campaign" element={<CampaignComponent />} />
        <Route path="/preview/virtualterminal" element={<VirtualTerminalComponent />} />
        <Route path="/preview/virtualterminal/marley" element={<VirtualTerminalComponent />} />
        <Route path="/preview/virtualterminal/nathania" element={<VirtualTerminalComponent />} />
        <Route path="/preview/virtualterminal/marni" element={<VirtualTerminalComponent />} />
        <Route path="/preview/virtualterminal/cindy" element={<VirtualTerminalComponent />} />
        <Route path="/preview/virtualterminal/chantelle" element={<VirtualTerminalComponent />} />
      </Routes>
    </div>
  );
}

export default App;
